import { useEffect, useRef } from "react"
import styled from "styled-components"
import { ArbeidsarkIcon, Input, type InputProps, SVGIcon } from "~/components"
import { useTranslate } from "~/ur-react-hooks"

interface WrapperProps {
  showInput: boolean
  mobile: boolean
}

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: row;
  border-radius: 999px;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 335px;
  border: 2px solid transparent;

  :focus-within {
    outline: none;
    border 2px solid ${(props) => props.theme.colors.primary};
  }

  input {
    display: ${(props) => (!props.showInput ? "block" : "none")};
    width: ${(props) => (!props.showInput ? "100%;" : "")};
    flex: 1;
    border: none !important;
    outline: none;
  }
  
  svg {
    width: 16px;
    height: 16px;
    opacity: 0.99;
  }
  
  ${(props) =>
    !props.showInput &&
    `
    justify-content: flex-end;
    `}
    `

interface InputWrapperProps {
  showInput: boolean
  collapsable: boolean
}
const InputWrapper = styled.div<InputWrapperProps>`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  align-content: stretch;
  border-radius: 9999px;
  ${(props) => (!props.showInput ? "background-color: white;" : "")}
  height: 40px;
  padding-left: 20px;
  padding-right: 15px;
  align-items: center;
  flex: 1;

  .--input-input {
    border: none;
  }

  .search-input {
    flex: 1;
    border: none;
    outline: none;
  }

  ${(props) => props.theme.media.desktop} {
    max-width: 100%;
    width: 100%;
  }

  ${(props) =>
    !props.showInput &&
    `
      box-shadow: ${props.theme.shadow.default}
    `}

  ${(props) =>
    props.collapsable &&
    `
      .search-icon:hover {
        cursor: pointer;
      `}
`

export interface HeaderSearchBarProps extends InputProps {
  collapsable?: boolean
  collapse?: boolean
  onToggle: () => void
}

export const HeaderSearch: React.FC<HeaderSearchBarProps> = ({
  onChange,
  value,
  collapsable = false,
  collapse = false,
  onToggle,
  ...props
}) => {
  const translations = useTranslate({
    searchPleaceholder: "worksheets.search-placeholder",
  })

  const magnifierClick = () => {
    if (collapsable) {
      onToggle()
    }
  }
  // If the input is shown via showInput change, set focus to input.
  useEffect(() => {
    if (!collapsable) return
    if (!collapse) {
      inputRef?.current?.focus()
    } else {
      inputRef?.current?.blur()
    }
  }, [collapse, collapsable])

  // Edge case, if bar is set to not be collapsable, make sure the input is usable.

  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <Wrapper mobile={collapsable} showInput={collapse}>
      <InputWrapper collapsable={collapsable} showInput={collapse}>
        <Input
          className="search-input"
          height="40px"
          onChange={onChange}
          value={value}
          placeholder={translations.searchPleaceholder}
          ref={inputRef}
          {...props}
        />
        <SVGIcon
          className="search-icon"
          width="16px"
          height="16px"
          icon={ArbeidsarkIcon.ShareNodes}
          onClick={magnifierClick}
        />
      </InputWrapper>
    </Wrapper>
  )
}
